var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c(
      "div",
      { staticClass: "text-center" },
      [
        _c("pulse-loader", {
          attrs: { loading: _vm.loading, color: _vm.color },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.calls && !_vm.loading
      ? _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tab-content bg-gray",
                attrs: { id: "nav-tabContent" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade show active",
                    attrs: {
                      id: "action_req",
                      role: "tabpanel",
                      "aria-labelledby": "nav-home-tab",
                    },
                  },
                  [
                    !_vm.calls.action_req.length
                      ? [_vm._m(1)]
                      : _vm._l(_vm.calls.action_req, function (task) {
                          return _c("div", { staticClass: "card" }, [
                            _c(
                              "div",
                              { staticClass: "card-body" },
                              [
                                _c("CabinOrdersRunnerTable", {
                                  attrs: {
                                    orders: [task.order],
                                    task: task,
                                    type: "viewOrder",
                                  },
                                }),
                                _vm._v(" "),
                                _c("taskActions", {
                                  attrs: {
                                    type: task.type,
                                    task: task,
                                    inStores: _vm.inStores,
                                    runners: _vm.runners,
                                  },
                                  on: { updateTasks: _vm.updateTasks },
                                }),
                              ],
                              1
                            ),
                          ])
                        }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    attrs: {
                      id: "no_action_req",
                      role: "tabpanel",
                      "aria-labelledby": "nav-home-tab",
                    },
                  },
                  [
                    !_vm.calls.no_action_req.length
                      ? [_vm._m(2)]
                      : _vm._l(_vm.calls.no_action_req, function (task) {
                          return _c("div", { staticClass: "card" }, [
                            _c(
                              "div",
                              { staticClass: "card-body" },
                              [
                                _c("CabinOrdersRunnerTable", {
                                  attrs: {
                                    orders: [task.order],
                                    task: task,
                                    type: "viewOrder",
                                  },
                                }),
                                _vm._v(" "),
                                _c("taskActions", {
                                  attrs: {
                                    type: task.type,
                                    task: task,
                                    inStores: _vm.inStores,
                                    runners: _vm.runners,
                                  },
                                  on: { updateTasks: _vm.updateTasks },
                                }),
                              ],
                              1
                            ),
                          ])
                        }),
                  ],
                  2
                ),
              ]
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("nav", [
      _c(
        "div",
        {
          staticClass: "nav nav-tabs",
          attrs: { id: "nav-tab", role: "tablist" },
        },
        [
          _c(
            "a",
            {
              staticClass: "nav-item nav-link active",
              attrs: {
                id: "nav-home-tab",
                "data-toggle": "tab",
                href: "#action_req",
                role: "tab",
                "aria-controls": "nav-home",
                "aria-selected": "true",
              },
            },
            [_vm._v("Требующие действий")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "nav-item nav-link",
              attrs: {
                id: "nav-profile-tab",
                "data-toggle": "tab",
                href: "#no_action_req",
                role: "tab",
                "aria-controls": "nav-profile",
                "aria-selected": "false",
              },
            },
            [_vm._v("Ознакомление")]
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center" }, [
      _c("p"),
      _c("h4", [_vm._v("Нет задач требующих действий")]),
      _c("p"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center" }, [
      _c("p"),
      _c("h4", [_vm._v("Нет задач для ознакомления")]),
      _c("p"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }